import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=8879f69e"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=8879f69e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports